import React from 'react';
import clsx from 'clsx';
import FieldErrors from './fieldErrors';
import { getDateCoercer } from '@/common/components/nikeforms/Date';
import { useReframe } from 'nike-re-framejs';
import { NfInput, makeField, TOUCH_ON_BLUR_ONLY_IF_CHANGED } from 'nike-form-js';

export function LabeledInput({
    form,
    path,
    label,
    hint,
    type,
    size,
    disabled = false,
    suppressError = false,
    autocomplete = 'off',
    autocapitalize,
    className,
    children,
    inputClassName,
    ...rest
}) {
    const field = makeField(form, path, type === 'date' ? getDateCoercer() : undefined);

    const { deref } = useReframe();
    const isTouched = deref(field.isTouched());
    const errors = deref(field.getErrors());
    const isError = isTouched && errors.size > 0 && !suppressError;
    const id = '' + path;

    return (
        <label
            data-path={path && path[0]}
            className={clsx(['nike-input', disabled ? 'nike-input-disabled' : null, className])}
        >
            {label ? <div className="nike-input-label">{label}</div> : null}
            {hint ? <div className="nike-input-hint">{hint}</div> : null}
            <NfInput
                field={field}
                attrs={Object.assign({}, rest, {
                    id,
                    type,
                    autoComplete: autocomplete,
                    autoCapitalize: autocapitalize,
                    disabled,
                    touchOnChange: false,
                    touchOnBlur: TOUCH_ON_BLUR_ONLY_IF_CHANGED,
                    className: clsx(size, inputClassName, { error: isError })
                })}
            />
            {children}
            {isError ? <FieldErrors errors={errors} /> : null}
        </label>
    );
}

export default LabeledInput;
